import * as React from "react";
import { connect } from "react-redux";

import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

// eslint-disable-next-line max-len
const HealthSurveillanceConsultationManualHandlingMSKQuestionnaireSectionUnconnected: React.FunctionComponent<CustomQuestionsQuestionnaireSectionProps> = (props: CustomQuestionsQuestionnaireSectionProps) => {
    const questions = Object.values(props.questions || {});
    const assessmentRequiredAnswer = "Issue Identified - MSK Assessment Required";
    const assessmentNotRequiredAnswer = "No Issue Identified - MSK Assessment Not Required";
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.ManualHandlingMSKQuestionnaire}
        >
            <DropdownQuestion
                readonly={props.readonly}
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingAssessmentRequired)}
                options={[assessmentNotRequiredAnswer, assessmentRequiredAnswer].map(a => ({ text: a, value: a }))}
                mandatory
            />
            {getAnswerToQuestionWithId(questions, questionIds.MSKManualHandlingAssessmentRequired) === assessmentRequiredAnswer &&
                <>
                    {YesNoWithFollowUpQuestion({
                        readonly: props.readonly,
                        questionConfigs: [
                            getQuestionConfig(props.questionConfigs, questionIds.MsdAssessmentUnableToCarryOut),
                            getQuestionConfig(props.questionConfigs, questionIds.MsdAssessmentUnableToCarryOutReason)
                        ],
                        mandatory: true,
                        followUpMandatory: true,
                        questions: props.questions
                    })}
                    {getAnswerToQuestionWithId(questions, questionIds.MsdAssessmentUnableToCarryOut) !== MultiButtonQuestion.YesOption && <>
                        <p>Locomotor System - Can patient demonstrate full movement of the following?</p>
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfNeck)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfBack)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftShoulder)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftElbow)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfRightShoulder)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfRightElbow)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftWrist)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfLeftLeg)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfRightWrist)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDemonstratedFullMovementOfRightLeg)}
                            mandatory
                        />
                        <MultiButtonQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDoRestrictionsAffectPerformance)}
                            mandatory
                        />
                        <TextQuestion
                            readonly={props.readonly}
                            questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MSKManualHandlingDoRestrictionsAffectPerformanceNotes)}
                            mandatory
                        />
                    </>}
                </>}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

export const HealthSurveillanceConsultationManualHandlingMSKQuestionnaireSection =
    connect(makeMapStateToQuestionnaireSectionProps(sections.ManualHandlingMSKQuestionnaire.id), mapDispatchToQuestionnaireSectionProps)
    (HealthSurveillanceConsultationManualHandlingMSKQuestionnaireSectionUnconnected);
